import { useMemo } from "react"

import { useProductInformationQuery } from "entities/products/graphql/product-information.queries.generated"

import { AggregatedProductData } from "../types/AggregatedProductData"

export function useAggregatedProductData(args: {
  variantKey: string
  configurationKey: string | null | undefined
  dimensioningKey: string | null | undefined
}): AggregatedProductData {
  const { variantKey, configurationKey, dimensioningKey } = args || {}

  const {
    data,
    loading: isLoadingProductInformation,
    error: productInformationError
  } = useProductInformationQuery({
    variables: {
      variantKey,
      dimensioningKey: dimensioningKey
        ? encodeURIComponent(dimensioningKey)
        : "",
      configurationKey: configurationKey
        ? encodeURIComponent(configurationKey)
        : ""
    }
  })

  const productInformation = useMemo(
    () => ({
      data: data?.productInformation,
      isLoading: isLoadingProductInformation,
      isUpdating: !!data?.productInformation && isLoadingProductInformation,
      error: !!productInformationError
    }),
    [
      data?.productInformation,
      isLoadingProductInformation,
      productInformationError
    ]
  )

  return { productInformation }
}
